// client/src/utils/notificationText.generated.js
//
// GENERATED - do not edit by hand.
//
// Copied from packages/core/src/account/notificationText.js by tools/sync-shared.py. Edit the core file and re-run that
// script; `node tools/marks-sheet-conformance.mjs` asserts this copy has not
// drifted from it.
//
// The phone imports the original. The web cannot (packages/core is outside
// client/src, and the CRA build will not resolve it), so it gets this. They must
// stay identical - a rule that exists twice and differs is the whole class of
// bug these files were written to end.
//
// What a notification SAYS. Both clients fell back to the bare type, so a
// server-generated row put marks_recorded on screen - a developer word for
// an event, shown to a parent. The server sends facts and the sentence is
// built here, so switching language re-reads old notifications too.

/**
 * A readable line for one notification.
 *
 * @param {object} n  the notification row
 * @param {Function} t  i18next's `t`
 */
export function describeNotification(n, t) {
  const p = (n && typeof n.payload === 'object' && n.payload) || {};
  const type = n && n.type;

  // A RESULT IS READY, AND DELIBERATELY NOT WHAT IT IS.
  //
  // The score lives behind the parent's own login beside the coefficient, the
  // class average and the teacher's remark that make it mean something. A
  // number on a lock screen has none of that and cannot be withdrawn — and is
  // read by whoever picks the phone up.
  if (type === 'marks_recorded') {
    const subject = p.subjectName || t('notifications.marks.aSubject', { defaultValue: 'a subject' });
    return p.evaluationName
      ? t('notifications.marks.withEvaluation', {
        subject,
        evaluation: p.evaluationName,
        defaultValue: `A result for ${subject} (${p.evaluationName}) has been recorded. Open the app to see it.`,
      })
      : t('notifications.marks.plain', {
        subject,
        defaultValue: `A result for ${subject} has been recorded. Open the app to see it.`,
      });
  }

  // THE AMOUNT IS INCLUDED HERE, and the asymmetry with marks is deliberate. A
  // balance is the parent's own business rather than the child's, it is the
  // single fact that decides whether they need to act, and a reminder that
  // makes you open an app to find out how much is a reminder people stop
  // opening.
  if (type === 'fee_due_soon') {
    const fee = p.feeName || t('notifications.fees.aFee', { defaultValue: 'School fees' });
    const amount = p.balance != null ? p.balance : null;
    const days = Number(p.daysLeft);
    const inDays = Number.isFinite(days) && days > 0
      ? t('notifications.fees.inDays', { count: days, defaultValue: `in ${days} days` })
      : t('notifications.fees.soon', { defaultValue: 'soon' });

    return amount != null
      ? t('notifications.fees.withAmount', {
        fee, amount, when: inDays,
        defaultValue: `${fee}: ${amount} is still outstanding, due ${inDays}.`,
      })
      : t('notifications.fees.plain', {
        fee, when: inDays,
        defaultValue: `${fee} is due ${inDays} and has not been paid.`,
      });
  }

  // Everything else keeps the chain that was there, MINUS the bare type. A row
  // nobody has written a sentence for should read as a notification, not as an
  // identifier — the generic word is a poor message and the identifier is not a
  // message at all.
  return (
    p.message
    || (n && n.message)
    || (n && n.title)
    || t('notifications.fallback', { defaultValue: 'Notification' })
  );
}

/** A MaterialCommunityIcons / MUI-ish glyph name for a notification type. */
export function iconForNotification(type) {
  if (type === 'marks_recorded') return 'clipboard-check-outline';
  if (type === 'fee_due_soon') return 'cash-clock';
  if (type === 'calendar_event_created') return 'calendar-plus';
  return 'bell-outline';
}
